import L from 'leaflet';

const DEFAULT_LOGO_URL = '/assets/logo.png';

export function buildMerchantIcon(merchant = {}) {
  const { logo } = merchant || {};
  const resolvedLogo = typeof logo === 'string' && logo.trim().length > 0 ? logo.trim() : DEFAULT_LOGO_URL;

  const html = `
    <div class="merchant-pin">
      <div class="merchant-pin-inner">
        <img src="${resolvedLogo}" alt="" onerror="this.onerror=null;this.src='${DEFAULT_LOGO_URL}';" />
      </div>
    </div>
  `;

  return L.divIcon({
    html,
    className: 'merchant-icon',
    iconSize: [56, 68],
    iconAnchor: [28, 62],
    popupAnchor: [0, -58]
  });
}






